<template>
  <v-container>
    <h1>{{ $t('user.userManagement') }}</h1>
    <v-data-table
      :headers="computedHeaders"
      :items="users"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('user.users') }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <add-user @user-added="fetchUsers" />
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editUser(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteUser(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="editDialog" max-width="800px">
      <user-edit
        v-if="editDialog"
        :user-id="editedUser.id"
        @close="editDialog = false"
        @user-updated="fetchUsers"
      />
    </v-dialog>
  </v-container>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue'
import { useI18n } from 'vue-i18n'
import axios from 'axios'
import AddUser from '@/components/AddUser.vue'
import UserEdit from '@/components/UserEdit.vue'

const { t } = useI18n()
const users = ref([])
const loading = ref(true)
const editDialog = ref(false)
const editedUser = ref({})
const computedHeaders = computed(() => [
  { title: t('user.id'), key: 'id' },
  { title: t('user.username'), key: 'username' },
  { title: t('user.actions'), key: 'actions', sortable: false }
])

onMounted(() => {
  fetchUsers()
})

async function fetchUsers() {
  loading.value = true
  try {
    const response = await axios.get('/api/users')
    users.value = response.data
  } catch (error) {
    console.error('Error fetching users:', error)
  } finally {
    loading.value = false
  }
}

function editUser(item) {
  editedUser.value = { ...item }
  editDialog.value = true
}

async function deleteUser(item) {
  if (confirm(`${t('user.confirmDelete')} ${item.username}?`)) {
    try {
      await axios.delete(`/api/users/${item.id}`)
      await fetchUsers()
    } catch (error) {
      console.error('Error deleting user:', error)
    }
  }
}
</script>

